import { render, staticRenderFns } from "./StockReportAgenciaTable.vue?vue&type=template&id=c5f70c0c"
import script from "./StockReportAgenciaTable.vue?vue&type=script&lang=js"
export * from "./StockReportAgenciaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports